import { Component } from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as wConst from "../consts/website-consts";

class PageListen extends Component {


  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      //console.log("Route dudes:", location);
      //console.log("Action dudes:", action);
      this.props.dispatch(wActs.loadPage());
    });
  }
  componentWillUnmount() {
    this.unlisten();
  }
  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ShowingLogin: state.Website.ShowingLogin,
    ShowingRegister: state.Website.ShowingLogin,
    WebPage: state.Website
  };
}


export default withRouter(connect(mapStateToProps)(PageListen));
